import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "header-padding" }, "Policies", -1)
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Create new policy", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Name", -1)

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import { MdmPolicySchema, StatsQuery } from '@/generated/sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'PoliciesPage',
  setup(__props) {

const store = useStore()
const router = useRouter()

const sortField = ref('name')
const sortOrder = ref(1)
const filter = ref('')
const showDialog = ref(false)
const creationLoading = ref(false)
const newPolicyName = ref('')

const stats = computed<StatsQuery>(() => store.state.app.stats)

const mdmPolicies = computed<MdmPolicySchema[]>(() =>
  store.state.policies.mdmPolicies
    ?.filter(p => {
      if (!filter.value.trim()) return true
      return p.name.toLowerCase().includes(filter.value.trim().toLowerCase())
    })
    .sort((a, b) => {
      let result = 0
      if (sortField.value === 'nApps') {
        result = (a.policy?.applications?.length || 0) - (b.policy?.applications?.length || 0)
      } else {
        // Sort by name is default
        result = a.name.localeCompare(b.name)
      }
      return sortOrder.value * result
    }),
)

function activeMdmDevicesByPolicy(policy: MdmPolicySchema) {
  return stats.value.countMdmDeviceByPolicyByDate.find(c => c.group === policy.googleId)?.count || 0
}

function totalMdmDevicesByPolicy(policy: MdmPolicySchema) {
  return stats.value.countPerPolicy.find(c => c.group === policy.googleId)?.count || 0
}

function rowClick(event) {
  router.push(`/policies/${event.data.id}`)
}

function sort(event) {
  sortField.value = event.sortField
  sortOrder.value = event.sortOrder
}

function getParentName(policy: MdmPolicySchema) {
  return mdmPolicies.value.find(p => policy.parent?.id === p.id)?.name || '-'
}

async function createPolicy() {
  showDialog.value = false
  creationLoading.value = true

  try {
    await store.dispatch('createPolicy', newPolicyName.value)
    newPolicyName.value = ''
  } finally {
    creationLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!
  const _component_DodoDialog = _resolveComponent("DodoDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DodoColumn, null, {
      default: _withCtx(() => [
        _createVNode(_component_DodoRow, { justify: "between" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_DodoButton, {
              color: "success",
              variant: "solid",
              disabled: creationLoading.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoIcon, { name: "add" }),
                _createTextVNode(" Create new policy ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_DodoRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              value: mdmPolicies.value,
              "responsive-layout": "scroll",
              paginator: true,
              rows: 25,
              "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              "rows-per-page-options": [10, 25, 100],
              "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
              "selection-mode": "single",
              style: {"width":"100%"},
              onSort: sort,
              onRowClick: rowClick
            }, {
              header: _withCtx(() => [
                _createVNode(_component_DodoRow, { justify: "end" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _hoisted_3,
                      _createVNode(_component_InputText, {
                        modelValue: filter.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter).value = $event)),
                        placeholder: "Search"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_PrimeColumn, {
                  field: "name",
                  header: "Name",
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeColumn, {
                  field: "name",
                  header: "Parent",
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(getParentName(data)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeColumn, {
                  field: "nApps",
                  header: "Number of apps",
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(data.policy?.applications?.length || 0), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeColumn, {
                  field: "active",
                  header: "Active this month"
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(activeMdmDevicesByPolicy(data)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeColumn, {
                  field: "total",
                  header: "Total"
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(totalMdmDevicesByPolicy(data)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DodoDialog, { active: showDialog.value }, {
      controls: _withCtx(() => [
        _createVNode(_component_DodoButton, {
          variant: "text",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cancel ")
          ]),
          _: 1
        }),
        _createVNode(_component_DodoButton, {
          variant: "solid",
          color: "info",
          onClick: createPolicy
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_InputText, {
          modelValue: newPolicyName.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPolicyName).value = $event)),
          placeholder: "Name"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}
}

})